export default function show_stripe_dialog() {
    window.open('/billing.html', 'billing test', "width=530,height=600,resizable,scrollbars=yes,status=1");
}
